import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import "./assets/fonts/stylesheet.css"
import "./assets/css/bootstrap.min.css"
import "./assets/css/animate.css"
import "./assets/css/modal.scss"
import "./assets/css/style.scss"
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
  </React.StrictMode>
);
